import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetTeamMembersQuery } from "../../features/members/TeamMembersApi";
import { useGetProjectsQuery } from "../../features/projects/ProjectsApi";
import { useEditTaskMutation } from "../../features/tasks/TasksApi";
import SelectList from "../ui/SelectList";

export default function EditTaskForm({task}) {
    const navigate = useNavigate();

    const [taskName, setTaskName] = useState(task.taskName);
	const [assignTo, setAssignTo] = useState(task.teamMember.id);
	const [project, setProject] = useState(task.project.id);
	const [deadline, setDeadline] = useState(task.deadline);
    
    const [ editTask, { isSuccess: isEditSuccess } ] = useEditTaskMutation();
    const { data: members, isSuccess: isMmemberFetchSuccess } = useGetTeamMembersQuery();
	const { data: projects, isSuccess: isProjectFetchSuccess } = useGetProjectsQuery();
    
    let teamMemberList = null;
	if (isMmemberFetchSuccess) {
		teamMemberList = members.map((t) => ({ id: t.id, text: t.name }));
	}

	let projectList = null;
	if (isProjectFetchSuccess) {
		projectList = projects.map((p) => ({ id: p.id, text: p.projectName }));
	}

    const handleFormSubmit = (e) => {
		e.preventDefault();

		let taskData = {
			taskName,
			teamMember: members.find(tm => tm.id == assignTo),
			project: projects.find(p => p.id == project),
			deadline,
            status: task.status
		};

		editTask({ id: task.id, data: taskData });
	};

    useEffect(() => {
        if (isEditSuccess) {
            navigate("/");
        }
    }, [isEditSuccess, navigate]);

	return (
		<form onSubmit={handleFormSubmit} className="space-y-6">
			<div className="fieldContainer">
				<label htmlFor="lws-taskName">Task Name</label>
				<input
					value={taskName}
					onChange={(e) => setTaskName(e.target.value)}
					type="text"
					name="taskName"
					id="lws-taskName"
					required
					placeholder="Implement RTK Query"
				/>
			</div>

			<div className="fieldContainer">
				<label>Assign To</label>
				{teamMemberList && (
					<SelectList
						options={teamMemberList}
						value={assignTo}
						setValue={setAssignTo}
						defaultText="Select Member"
						name="teamMember"
						id="lws-teamMember"
						required
					/>
				)}
			</div>
			<div className="fieldContainer">
				<label htmlFor="lws-projectName">Project Name</label>
				{projectList && (
					<SelectList
						options={projectList}
						value={project}
						setValue={setProject}
						defaultText="Select Project"
						id="lws-projectName"
						name="projectName"
						required
					/>
				)}
			</div>

			<div className="fieldContainer">
				<label htmlFor="lws-deadline">Deadline</label>
				<input
					value={deadline}
					onChange={(e) => setDeadline(e.target.value)}
					type="date"
					name="deadline"
					id="lws-deadline"
					required
				/>
			</div>

			<div className="text-right">
				<button type="submit" className="lws-submit">
					Save
				</button>
			</div>
		</form>
	);
}
